import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { InventoryBasicSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { createToast, errorToast, toastType } from 'Common/ToastHelper';

import {
  getInventoryBasicSetup,
  inventoryBasicSetupDelete,
  inventoryBasicSetupInsertUpdate,
  clearInventoryBasicSetupData,
} from './state/actions';
import InventoryBasicSetupComponent from './components/InventoryBasicSetupComponent';
import * as SetUpSelector from './state/selectors';

class InventoryBasicSetupContainer extends Component {
  static defaultProps = {
    loadingSetUpError: null,
    submitError: null,
    loadingSetUp: false,
    setUpData: [],
    isSetUpSubmitting: false,
  };
  static propTypes = {
    getInventoryBasicSetup: PropTypes.func.isRequired,
    inventoryBasicSetupDelete: PropTypes.func.isRequired,
    inventoryBasicSetupInsertUpdate: PropTypes.func.isRequired,
    clearInventoryBasicSetupData: PropTypes.func.isRequired,
    loadingSetUp: PropTypes.bool,
    setUpData: PropTypes.array,
    isSetUpSubmitting: PropTypes.bool,
    loadingSetUpError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    submitted: PropTypes.bool.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    submitSuccessMsg: PropTypes.string.isRequired,
  };
  state = {
    open: false,
    rowData: { Id: 0, Description: '' },
    size: 'mini',
    isValid: false,
    showDeleteModal: false,
  };

  componentDidMount() {
    this.props.getInventoryBasicSetup(this.props.resourceName);
  }

  componentWillUnmount() {
    this.props.clearInventoryBasicSetupData();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.idleTimeUTC !== this.props.idleTimeUTC) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps) {
    const { clearInventoryBasicSetupData, submitSuccessMsg } = this.props;
    if (
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'loadingSetUpError')
    ) {
      clearInventoryBasicSetupData();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', submitSuccessMsg, true);
      clearInventoryBasicSetupData();
    }
  }

  close = () => this.setState({ open: false });

  deleteInventoryBasicSetup = row => {
    this.setState({
      rowData: {
        Id: row.Id,
        Description: row.Description,
      },
      showDeleteModal: true,
    });
  };

  editInventoryBasicSetup = row => {
    this.setState({
      rowData: {
        Id: row.Id,
        Description: row.Description,
      },
      open: true,
      isValid: true,
    });
  };

  addInventoryBasicSetup = () => {
    this.setState({
      rowData: { Id: 0, Description: '' },
      open: true,
      isValid: false,
    });
  };

  handleSubmit = values => {
    const { inventoryBasicSetupInsertUpdate, resourceName } = this.props;
    const { rowData } = this.state;

    const data = {
      Id: values[Fields.Id],
      Description: _.trim(values[Fields.Description]),
      IsNew: rowData.Id ? false : true,
    };

    inventoryBasicSetupInsertUpdate(resourceName, data).then(() => {
      this.setState({ open: false });
    });
  };

  setIsValid = isValid => {
    this.setState({ isValid });
  };

  handleDialog = result => {
    if (result) {
      const { inventoryBasicSetupDelete, resourceName } = this.props;
      inventoryBasicSetupDelete(resourceName, this.state.rowData.Id);
    }
    this.setState({ showDeleteModal: false });
  };

  clearFilters = () => {
    this.setState({ filtered: [] });
  };

  onFilteredChange = filtered => {
    this.setState({ filtered });
  };

  render() {
    const { open, size, rowData, isValid, showDeleteModal } = this.state;
    const {
      setUpData,
      loadingSetUp,
      humanName,
      isReadOnly,
      isSetUpSubmitting,
    } = this.props;

    return (
      <InventoryBasicSetupComponent
        open={open}
        size={size}
        rowData={rowData}
        isValid={isValid}
        loading={loadingSetUp}
        showDeleteModal={showDeleteModal}
        setUpData={setUpData}
        sortById={true}
        addInventoryBasicSetup={this.addInventoryBasicSetup}
        editInventoryBasicSetup={this.editInventoryBasicSetup}
        deleteInventoryBasicSetup={this.deleteInventoryBasicSetup}
        handleDialog={this.handleDialog}
        handleSubmit={this.handleSubmit}
        setIsValid={this.setIsValid}
        close={this.close}
        filtered={this.state.filtered}
        onFilteredChange={this.onFilteredChange}
        clearFilters={this.clearFilters}
        humanName={humanName}
        isReadOnly={isReadOnly}
        isSetUpSubmitting={isSetUpSubmitting}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    loadingSetUp: SetUpSelector.getLoadingSetUp(state),
    setUpData: SetUpSelector.getSetUpData(state),
    loadingSetUpError: SetUpSelector.getLoadingSetUpError(state),
    isSetUpSubmitting: SetUpSelector.getIsSetUpSubmitting(state),
    submitted: SetUpSelector.getSubmitted(state),
    submitError: SetUpSelector.getSubmitError(state),
    submitSuccessMsg: SetUpSelector.getSubmitSuccessMsg(state),
  };
};

const mapDispatchToProps = {
  getInventoryBasicSetup,
  inventoryBasicSetupDelete,
  inventoryBasicSetupInsertUpdate,
  clearInventoryBasicSetupData,
};
export const InventoryBasicSetup = connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryBasicSetupContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/InventoryBasicSetup.js